var ProfileSheetTestIdEnum = /* @__PURE__ */ ((ProfileSheetTestIdEnum2) => {
  ProfileSheetTestIdEnum2["PROFILE_MENU_CONTENT"] = "profile-menu--content";
  ProfileSheetTestIdEnum2["PROFILE_MENU_GREETING"] = "profile-menu-greeting";
  ProfileSheetTestIdEnum2["ITEM_CART"] = "profile-menu-item-cart";
  ProfileSheetTestIdEnum2["ITEM_APPOINTMENTS"] = "profile-menu-item-appointments";
  ProfileSheetTestIdEnum2["ITEM_PROFILE"] = "profile-menu-item-profile";
  ProfileSheetTestIdEnum2["ITEM_DEPENDENTS"] = "profile-menu-item-dependents";
  ProfileSheetTestIdEnum2["ITEM_FAVORITES"] = "profile-menu-item-favorites";
  ProfileSheetTestIdEnum2["ITEM_COUPONS"] = "profile-menu-item-coupons";
  ProfileSheetTestIdEnum2["ITEM_FEEDBACK"] = "profile-menu-item-feedback";
  ProfileSheetTestIdEnum2["ITEM_HELP"] = "profile-menu-item-help";
  ProfileSheetTestIdEnum2["LOGOUT"] = "profile-menu-logout";
  return ProfileSheetTestIdEnum2;
})(ProfileSheetTestIdEnum || {});
export {
  ProfileSheetTestIdEnum
};
